import { createContext } from 'react';
import { PropertyPricingModalContextProps } from './PropertyPricingModal.types';

const PropertyPricingModalContext =
  // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  createContext<PropertyPricingModalContextProps>(undefined);

export default PropertyPricingModalContext;
